let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2qi1w")).then(() => parcelRequire('i04af'));